import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { TextField } from '@material-ui/core';

const Textarea = (props) => {
    const { control, name, label, rules, inputProps, onChange, type, rows, multiline, variant, capitalize, disabled } = props;

	return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue=""
            render={({ field }) => (
                <TextField
                    {...field}
                    disabled={disabled}
                    variant={variant || 'standard'}
                    margin="normal"
                    label={label}
                    multiline={multiline}
                    autoComplete={name}
                    inputProps={{
                        ...inputProps,
                        // TODO remove if not needed
                        ...(capitalize && { style: { textTransform: 'none' } })
                    }}
                    type={type || 'text'}
                    rows={rows}
                    onChange={onChange || field.onChange}
                    onBlur={field.onBlur}
                    fullWidth
                />
            )}
        />
	);
}

Textarea.propTypes = {
    control: PropTypes.object,
    name: PropTypes.string,
    variant: PropTypes.string,
    label: PropTypes.string,
    rules: PropTypes.object,
    rows: PropTypes.number,
    multiline: PropTypes.bool,
    inputProps: PropTypes.object,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    type: PropTypes.string,
    capitalize: PropTypes.bool,
    disabled: PropTypes.bool
}

export default Textarea;
